import { render, staticRenderFns } from "./DeskCreate.vue?vue&type=template&id=3728e010&"
import script from "./DeskCreate.vue?vue&type=script&lang=js&"
export * from "./DeskCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports